import { jsx, jsxs } from "react/jsx-runtime";
import { Box, Text, Anchor, IconButton, Icon } from "@zillow/constellation-10";
import { IconChevronDownOutline } from "@zillow/constellation-icons";
import { yieldCallback } from "@zillow/yield-callback";
import "react";
import { useDropdownBehavior } from "../../hooks/useDropdownBehavior.esm.js";
import { getCmsInfoForPage } from "../../utils/clickstream/getCmsInfoForPage.esm.js";
import { sendEvent } from "./B2BMainNav.utils.esm.js";
import ColumnsNav from "./ColumnsNav.esm.js";
import Dropdown from "./Dropdown.esm.js";
import { usePageProps } from "@zillow/cms-utils";
const MenuItem = ({
  item,
  transparent,
  css: cssProp
}) => {
  const {
    dropdown,
    setDropdown,
    ref,
    onMouseEnter,
    onMouseLeave
  } = useDropdownBehavior();
  const pageProps = usePageProps();
  const cmsInfo = getCmsInfoForPage(pageProps);
  const sendCmsAnchorEventOnClick = (item2) => {
    sendEvent("cms_anchor", item2.label, item2.url, cmsInfo);
  };
  const hasColumns = item.columns && item.columns.length > 0;
  const hasChildren = item.children && item.children.length > 0;
  const chevronTitle = dropdown ? `Close ${item.label} menu` : `Open ${item.label} menu`;
  const linkColor = transparent ? "text.onImpact.neutral-fixed" : "text.neutral";
  const linkHover = transparent ? "text.onImpact.neutral-fixed" : "text.accent.brand.hero";
  if (hasColumns || hasChildren) {
    return /* @__PURE__ */ jsx(Box, { asChild: true, ref, onMouseEnter, onMouseLeave, css: {
      ...cssProp,
      display: "flex",
      alignItems: "center",
      position: !hasColumns ? "relative" : "static",
      xlDown: {
        borderBottomWidth: "1px",
        borderBottomStyle: "solid",
        borderBottomColor: "border.muted",
        flexDirection: "column",
        alignItems: "stretch",
        width: "100%"
      }
    }, children: /* @__PURE__ */ jsxs("li", { children: [
      /* @__PURE__ */ jsxs(Box, { css: {
        display: "flex",
        alignItems: "center",
        gap: "0",
        width: "100%",
        xlDown: {
          justifyContent: "space-between",
          padding: "default"
        }
      }, children: [
        /* @__PURE__ */ jsx(Text, { textStyle: "body", asChild: true, children: /* @__PURE__ */ jsx(Anchor, { href: item.url, target: item.target, rel: item.target === "_blank" ? "noopener noreferrer" : void 0, onClick: (e) => {
          if (item.url === "#") {
            e.preventDefault();
            setDropdown(!dropdown);
          } else {
            sendCmsAnchorEventOnClick(item);
          }
        }, "aria-haspopup": "menu", "aria-expanded": dropdown ? "true" : "false", css: {
          display: "flex",
          alignItems: "center",
          textDecoration: "none",
          color: linkColor,
          _hover: {
            color: linkHover
          },
          _focusVisible: {
            color: linkHover
          },
          xl: {
            width: "auto",
            height: "100%",
            paddingBlock: "tighter",
            paddingInlineStart: "default",
            paddingInlineEnd: "none"
          },
          xlDown: {
            flex: 1
          }
        }, children: item.label }) }),
        /* @__PURE__ */ jsx(IconButton, { emphasis: "bare", size: "xs", tone: transparent ? "neutral-fixed" : "neutral", onImpact: transparent, title: chevronTitle, "aria-haspopup": "menu", "aria-expanded": dropdown ? "true" : "false", "aria-label": chevronTitle, icon: /* @__PURE__ */ jsx(Icon, { size: "sm", css: {
          color: linkColor
        }, children: /* @__PURE__ */ jsx(IconChevronDownOutline, {}) }), css: {
          color: linkColor,
          marginInlineStart: "none",
          "&:hover": {
            backgroundColor: "transparent",
            color: linkHover
          },
          "&:focus-visible": {
            color: linkHover
          }
        }, onClick: () => setDropdown(!dropdown) })
      ] }),
      hasColumns ? /* @__PURE__ */ jsx(ColumnsNav, { columns: item.columns, transparent, isVisible: dropdown, onMouseEnter, onMouseLeave }) : /* @__PURE__ */ jsx(Dropdown, { submenus: item.children, dropdown })
    ] }) });
  }
  return /* @__PURE__ */ jsx(Box, { asChild: true, css: {
    ...cssProp,
    display: "flex",
    alignItems: "center",
    xlDown: {
      borderBottomWidth: "1px",
      borderBottomStyle: "solid",
      borderBottomColor: "border.muted",
      flexDirection: "column",
      width: "100%"
    },
    _hover: {
      color: linkHover,
      cursor: "pointer"
    }
  }, children: /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(Text, { textStyle: "body", asChild: true, children: /* @__PURE__ */ jsx(Anchor, { href: item.url, target: item.target, rel: item.target === "_blank" ? "noopener noreferrer" : void 0, onClick: yieldCallback(() => {
    sendCmsAnchorEventOnClick(item);
  }), css: {
    color: linkColor,
    paddingBlock: "tighter",
    paddingInline: "default",
    textDecoration: "none",
    _visited: {
      color: linkColor
    },
    _hover: {
      color: linkHover
    },
    xlDown: {
      padding: "default",
      width: "100%"
    }
  }, children: item.label }) }) }) });
};
export {
  MenuItem as default
};
